// services/notificationService/create.ts - services/notificationService.ts split (sub-module create)

import { supabase } from '../../supabase';


// Create notification for a user
export async function createNotification(
  userId: string,
  payload: { type: string; title: string; message: string; metadata?: Record<string, any> }
) {
  try {
    // Samakan dengan CHECK constraint DB (notifications_type_check).
    // 'FOLLOWUP_REMINDER' & 'DIGITAL_ORDER_NEW' DITOLAK DB → 400, jadi
    // dinormalisasi ke tipe valid + metadata.event_type (pola NOTIFICATION_400_FIX.md).
    const typeMap: Record<string, string> = {
      FOLLOWUP_REMINDER: 'SYSTEM_ALERT',
      DIGITAL_ORDER_NEW: 'ORDER_NEW',
      new_order: 'ORDER_NEW',
      abandoned_cart: 'CART_ABANDON',
      user_signup: 'SYSTEM_ALERT',
      order_status_change: 'SYSTEM_ALERT',
    };
    const safeType: string = typeMap[payload.type] || payload.type;
    const metadata = { ...(payload.metadata || {}) };
    if (safeType !== payload.type && !metadata.event_type) {
      metadata.event_type = payload.type.toLowerCase();
    }

    const { error } = await supabase
      .from('notifications')
      .insert({
        user_id: userId,
        type: safeType,
        title: payload.title,
        message: payload.message,
        metadata,
        is_read: false,
        is_deleted: false,
      });

    if (error) {
      console.debug('[NotificationService] Insert failed (non-critical):', error.message);
      return null;
    }

    return { id: 'created', type: safeType, title: payload.title } as any;
  } catch (err) {
    console.debug('[NotificationService] Exception (non-critical):', err);
    return null;
  }
}
